import { useEffect, useRef, useState } from "react";
import { isSelectableLayer } from "./excludeFromSelection";
import { useMap } from "./useMap";
import { MapBrowserEvent } from "ol";
import { mouseActionButton } from "ol/events/condition";
import Feature, { FeatureLike } from "ol/Feature";
import { Geometry } from "ol/geom";

export function useSelectAnnotation() {
  const [selectedAnnotation, setSelectedAnnotation] =
    useState<FeatureLike | null>(null);

  const map = useMap();

  // ref로 최신 상태 유지 — 이벤트 핸들러가 항상 최신 selectedAnnotation을 참조
  const selectedRef = useRef(selectedAnnotation);
  useEffect(() => {
    selectedRef.current = selectedAnnotation;
  }, [selectedAnnotation]);

  // 안정적인 이벤트 핸들러 등록 — map 변경 시에만 재등록
  useEffect(() => {
    const getAnnotationByClick = (event: MapBrowserEvent<any>) => {
      // 수정/그리기 중에는 지도 이동 및 다른 클릭 로직을 막아 선택만 처리
      if (map.get("isModifying") || map.get("isDrawing")) {
        event.preventDefault();
        event.stopPropagation();
      }
      // 좌클릭만 허용 (singleclick 기준)
      if (!mouseActionButton(event)) return;

      const clickedFeatures = map.getFeaturesAtPixel(event.pixel, {
        hitTolerance: 12,
        layerFilter: isSelectableLayer,
      });

      if (clickedFeatures.length > 0) {
        const selectedFeature = clickedFeatures[0] as Feature<Geometry>;
        if (selectedRef.current !== selectedFeature) {
          setSelectedAnnotation(selectedFeature);
        }
      }
    };

    map.on("singleclick", getAnnotationByClick);
    return () => {
      map.un("singleclick", getAnnotationByClick);
    };
  }, [map]);

  return selectedAnnotation as Feature<Geometry>;
}
